import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import GraphicEqRoundedIcon from '@mui/icons-material/GraphicEqRounded';
import ROUTES from '@src/constants/route';
import LocalMoviesRoundedIcon from '@mui/icons-material/LocalMoviesRounded';
// import AddRoundedIcon from '@mui/icons-material/AddRounded';

import { StyleRequestDashboard } from './index.style';
import TTSNew from '../TTSNew';
// import ListProject from '../NewDubbing/ListProject';

const RequestDashboard = () => {
  const { t } = useTranslation();
  const STUDIO_PACKAGE = 'STUDIO_PACKAGE';
  const DUBBING = 'DUBBING';
  const products = [
    {
      name: t('studioPackage'),
      icon: <GraphicEqRoundedIcon />,
      link: ROUTES.TTS,
      key: STUDIO_PACKAGE,
    },
    {
      name: t('MBF-DUBBING'),
      icon: <LocalMoviesRoundedIcon />,
      link: ROUTES.DUBBING,
      key: DUBBING,
    },
  ];
  const [chooseProduct, setChooseProduct] = useState(STUDIO_PACKAGE);
  const history = useHistory();

  const handleClickAddRequest = () => {
    history.push(
      chooseProduct === STUDIO_PACKAGE ? ROUTES.TTS : ROUTES.DUBBING,
    );
  };

  return (
    <StyleRequestDashboard>
      <div className="product">
        {products.map((pro) => (
          <button
            className={chooseProduct === pro.key && 'bg-white'}
            type="button"
            onClick={() => setChooseProduct(pro.key)}
          >
            {pro.icon}
            <p className="name">{pro.name}</p>
          </button>
        ))}
      </div>
      {chooseProduct === STUDIO_PACKAGE ? (
        <TTSNew
          isNewHomepage
          onClickAddRequest={handleClickAddRequest}
          // {...(chooseProduct === DUBBING && { isDubbingTitle: true })}
        />
      ) : (
        <></>
        // <ListProject />
      )}
    </StyleRequestDashboard>
  );
};

export default RequestDashboard;
